import fetchApi from '../../Services/requests';
import {
  GetOtpCodeUrl,
  ResendOtpUrl,
  SendOtpUrl
} from '../../Routes/account.route';
import useProfileStore from '../Profile';
import useLandingStore from '../Landing';

export const getOtpCodeAction = async (
  set,
  phoneNumber: string,
  branchId: number
): Promise<boolean> => {
  set({ otpRequestLoading: true, otpRequestError: false });
  const response = await fetchApi(GetOtpCodeUrl(), { phoneNumber, branchId });

  if (response?.ok) {
    set({ otpRequestLoading: false, phoneNumber: phoneNumber });
    return true;
  } else {
    set({ otpRequestLoading: false, otpRequestError: true });
    return false;
  }
};

export const sendOtpCodeAction = async (
  set,
  phoneNumber: string,
  confirmationCode: string,
  uniqueId: number,
  navigate
): Promise<void> => {
  set({ sendOtpLoading: true, sendOtpError: false });
  const response = await fetchApi(SendOtpUrl(), {
    phoneNumber,
    confirmationCode,
    uniqueId
  });

  const accessToken = response?.data?.access_token;
  const refreshToken = response?.data?.refresh_token;

  // API may return HTTP 200 with only a `message` when OTP is invalid/expired
  if (response?.ok && accessToken) {
    set({ sendOtpLoading: false });
    localStorage.setItem('access_token', accessToken);
    localStorage.setItem('refresh_token', refreshToken || '');

    // Get landing data to get the correct branch ID
    const landingStore = useLandingStore.getState();
    const landingData = landingStore.landingData;

    if (landingData?.branchId) {
      // Get profile data to check if it's complete
      const profileComplete = await useProfileStore
        .getState()
        .getProfileDataAction(landingData.branchId);

      if (profileComplete) {
        // Get fresh state after the action completes
        const profileData = useProfileStore.getState().profileData;
        // Check if required fields (name, sex) are missing or empty (excluding email)
        const hasName = profileData?.name && profileData.name.trim().length > 0;
        const hasSex = profileData?.sex && profileData.sex.trim().length > 0;
        const isProfileIncomplete = !hasName || !hasSex;

        if (isProfileIncomplete) {
          navigate('/profile/edit', {
            state: {
              name: profileData?.name || '',
              birthday: profileData?.birthday,
              email: profileData?.email ?? '',
              mobile: profileData?.mobile,
              sex: profileData?.sex || ''
            }
          });
        } else {
          navigate('/credits', { replace: true });
        }
      } else {
        navigate('/credits', { replace: true });
      }
    } else {
      // If we don't have landing data yet, just go to credits
      navigate('/credits', { replace: true });
    }
  } else {
    set({ sendOtpLoading: false, sendOtpError: true });
  }
};

export const resendOtpCodeAction = async (
  set,
  phoneNumber: string,
  branchId: number
): Promise<boolean> => {
  set({
    otpRequestLoading: true,
    otpRequestError: false,
    sendOtpError: false,
    sendOtpLoading: false
  });
  const response = await fetchApi(ResendOtpUrl(), { phoneNumber, branchId });

  if (response?.ok) {
    set({ otpRequestLoading: false });
    return true;
  } else {
    set({ otpRequestLoading: false, otpRequestError: true });
    return false;
  }
};
